<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="item" :class="{active:country===item.country}" v-for="(item,index) in list" :key="index"
                     @click="selectCountry(item.country)">
                    <img :src="require(`./../../assets/image/${item.img}`)" alt="">
                    <div class="icon">
                        <div class="border">
                            <i class="iconfont icon-dagou"></i>
                        </div>
                    </div>
                    <div class="animate__animated animate__flash wrong" v-if="error && select===item.country">
                        <i class="iconfont icon-wrong" style="font-size: 100px;color: red"></i>
                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" v-if="$route.meta.prev" @click="$router.push($route.meta.prev)">
                    上一步
                </span>
                <span class="btn" @click="next()" v-if="$store.state.record.country!==''">
                    下一步
                </span>
            </div>
            <el-dialog
                    title="提示"
                    fullscreen
                    :visible.sync="dialogVisible">
                <span>
                    <img src="./../../assets/image/tj.png" alt="" v-if="select==='RUS'">
                    <img src="./../../assets/image/yrf.png" alt="" v-else>
                </span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">关 闭</el-button>
                  </span>
            </el-dialog>
            <dialogue v-if="showQuestion" :img="img" next-route="/goods-collection/warehouseCheck" :talk-list-init="talkList"></dialogue>
        </div>
    </scroll-wrap>
</template>

<script>
    import dialogue from '../../components/dialogue'
    export default {
        name: "investigate",
        components: {
            dialogue
        },
        data() {
            return {
                list: [
                    {
                        country: 'RUS',
                        img: 'Russia.png',
                    },
                    {
                        country: 'MY',
                        img: 'Malaysia.png',
                    }
                ],
                error: false,
                select: '',
                dialogVisible:false,
                showQuestion:false
            }
        },
        computed: {
            country() {
                return this.$store.state.record.country
            },
            img(){
                let img = this.$store.state.record.country === 'MY' ? 'tj' : 'yrf'
                return {
                    url: require(`./../../assets/image/${img}.jpg`),
                    srcList: [
                        require(`./../../assets/image/${img}.jpg`)
                    ],
                }
            },
            talkList(){
                if(this.$store.state.record.country === 'MY'){
                    return [
                        {
                            txt: `根据系统提供的真丝头巾销量趋势图，你认为海外仓总计最佳库存数量应为多少？`,
                            type: 'teacher',
                            options: ["A、1万条","B、2万条","C、3万条"],
                            rightAnswers: '正确答案:C、3万条。一般按三个月销售量进行海外仓备货。',
                            answer: '',
                            value: "C、3万条",
                            next: true,
                            questionIndex:1,
                            score:6,
                            questionType:'choice'
                        },
                        {
                            txt: `真丝头巾出口外包装尺寸：25*45*3cm，一条真丝头巾的重量是50g。根据已有资料，推算真丝头巾海外仓总计使用仓位的容积，最恰当应选哪个？`,
                            type: 'teacher',
                            options: ["A、100m³","B、110m³","C、120m³"],
                            rightAnswers: '正确答案:B、110m³。应按最佳库存量即三个月的销售量进行备货，计算容积公式：0.25*0.45*0.03*30000=101.25 m³，选100 m³则不够空间存放，选120 m³则有些浪费，扣除必要空间消耗，则选110 m3最理想。',
                            answer: '',
                            value:"B、110m³",
                            next: true,
                            questionIndex:2,
                            score:6,
                            questionType:'choice',
                        },
                        {
                            txt: `真丝头巾出口外包装尺寸：25*45*3cm，一条真丝头巾的重量是50g，库存数量30000条。假设马来西亚仓库租金：每立米每月13美元（含税收等综合费用）。根据已有资料，计算羽绒服三个月海外仓总计花费多少美元？`,
                            type: 'teacher',
                            options: ["A、4290","B、4390","C、4490"],
                            rightAnswers: '正确答案:A、4290。根据以上计算出的最佳仓位容积，计算费用公式：13*110*3=4290，故最佳答案为A。',
                            answer: '',
                            value:'A、4290',
                            questionIndex:3,
                            score:6,
                            next: true,
                            questionType:'choice'
                        }
                    ]
                }else {
                    return  [
                        {
                            txt: `根据系统提供的羽绒服销量趋势图，你认为海外仓总计最佳库存数量应为多少？`,
                            type: 'teacher',
                            options: ["A、2000件", "B、4000件", "C、6000件"],
                            rightAnswers: '正确答案：C、6000件。解析：一般按三个月销售量进行海外仓备货。',
                            answer: '',
                            value:"C、6000件",
                            questionIndex:1,
                            score:6,
                            next: true,
                            questionType:'choice'
                        },
                        {
                            txt: `羽绒服出口外包装尺寸：60*50*15cm，一件羽绒服重量是100g；根据已有资料，推算羽绒服海外仓总计使用仓位的容积，最恰当应选哪个？`,
                            type: 'teacher',
                            options: ["A、265m³", "B、275m³", "C、285m³"],
                            rightAnswers: '正确答案:B、275m³。 应按最佳库存量即三个月的销售量进行备货，计算容积公式：0.6*0. 5*0.15*6000=270m³，选265m³则不够空间存放，选285m³则有些浪费，扣除必要空间消耗，则选275m³最理想。',
                            answer: '',
                            value:"B、275m³",
                            next: true,
                            questionIndex:2,
                            score:6,
                            questionType:'choice'
                        },
                        {
                            txt: `羽绒服出口外包装尺寸：60*50*15cm，一件羽绒服重量是100g，库存数量6000件。假设俄罗斯仓库租金：每立米每月50美元（含税收等综合费用）。根据已有资料，计算羽绒服三个月海外仓总计花费多少美元？`,
                            type: 'teacher',
                            options: ["A、41250", "B、43250", "C、45250"],
                            rightAnswers: '正确答案: A、41250。 根据以上计算出的最佳仓位容积，计算费用公式：50*275*3=41250，故最佳答案为A。',
                            answer: '',
                            value:'A、41250',
                            next: true,
                            questionIndex:3,
                            score:6,
                            questionType:'choice'
                        }
                    ]
                }
            }
        },
        created() {
            this.select = this.$store.state.record.country
        },
        methods: {
            selectCountry(item) {
                this.error = false;
                this.select = item;
                this.$store.commit('setState', {key: 'record.country', value: item})
            },
            next() {
                let _country = this.$store.state.record.template.id === 1 ? 'MY' : 'RUS';
                if (_country === this.select) {
                    this.$store.state.record.caseIndex = 1;
                    this.showQuestion = true
                } else {
                    this.error = true;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @keyframes move {
        0% {
            top: 0;
        }
        100% {
            top: 40px;
        }
    }

    .dialog {
        position: fixed;
        top: -100px;
        left: 50%;
        transform: translateX(-50%);

        &.error {
            animation: move 0.3s ease-in-out both;
        }
    }

    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 40px;
            padding-bottom: 40px;
            min-height: calc(100% - 88px);

            .item {
                margin-right: 120px;
                cursor: pointer;
                transition: all 0.3s ease-in-out;
                position: relative;

                > .wrong {
                    position: absolute;
                    top: 0;
                    right: 0;
                    opacity: 0;
                }

                &.active {
                    > .icon {
                        border-color: #FBB521;

                        > .border {
                            background: #FBB521;

                            > i {
                                color: #FFFFFF;
                            }
                        }
                    }
                }

                &:hover {
                    transform: scale(1.02);
                    transition: all 0.3s ease-in-out;
                }

                &:last-child {
                    margin-right: 0;
                }

                > img {
                    width: 460px;
                }

                > .icon {
                    margin-top: 20px;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #9e9e9e;
                    position: relative;
                    left: 60%;

                    .border {
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        background: #9e9e9e;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 16px;

                        > i {
                            color: #FFFFFF;

                        }
                    }
                }
            }
        }

        .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;border-radius:0 0 10px 10px;
            height: 88px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
